import { FulfillmentGroupCsvColumn } from "@redotech/redo-fulfillment-common/csv-column";
import {
  getLotNumbers,
  getLotsForExpandedItem,
} from "@redotech/redo-fulfillment-common/lot/line-item-lots";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { getExpandedItems } from "./fulfillment-group-csv-utils";

export function getLotNumberCell(row: FulfillmentGroupData): string {
  return getLotNumbers(row.items ?? []).join(", ");
}

export function getLotNumberUnitCell(
  row: FulfillmentGroupData,
  expansionIndex: number,
): string {
  const expandedItems = getExpandedItems(row);
  const rowQuantity = expandedItems[expansionIndex]?.quantity ?? 0;
  const lots = getLotsForExpandedItem(expandedItems, expansionIndex);
  const [only] = lots;
  if (lots.length === 1 && only && only.units === rowQuantity) {
    return only.lot.lotNumber ?? "";
  }
  return lots
    .map(({ lot, units }) => `${lot.lotNumber ?? ""} (${units})`)
    .join(", ");
}

export const LotNumberCsvColumn: FulfillmentGroupCsvColumn<FulfillmentGroupData> =
  {
    header: "Lot number",
    cell: getLotNumberCell,
    expandedCsvCell: getLotNumberUnitCell,
  };
